var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 px-1 py-2" }, [
        _c("h1", { staticClass: "mb-0 pb-0", attrs: { id: "page-title" } }, [
          _vm._v("\n                " + _vm._s(_vm.title) + "\n            "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }